var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-dialog",
    {
      attrs: {
        width: "500"
      },
      model: {
        value: _vm.dialog,
        callback: function callback($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "gg-toolbar",
            {
              on: {
                close: _vm.close
              }
            },
            [_vm._v(" Key Generation Complete! ")]
          ),
          _c(
            "v-card-text",
            [
              _c("v-textarea", {
                attrs: {
                  outlined: "",
                  value: _vm.reason,
                  readonly: "",
                  "hide-details": "",
                  rows: "8"
                }
              })
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c(
                "gg-btn",
                {
                  staticClass: "mb-0 ml-0",
                  attrs: {
                    text: "",
                    color: "green"
                  },
                  on: {
                    click: _vm.close
                  }
                },
                [_vm._v("Close")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }